import { useCountUp } from '@/hooks/useCountUp';

interface AnimatedPriceProps {
  value: number;
  duration?: number;
  enabled: boolean;
  className?: string;
  prefix?: string;
  suffix?: string;
  locale?: string;
  currency?: string;
}

export function AnimatedPrice({
  value,
  duration = 1800,
  enabled,
  className = '',
  prefix = '',
  suffix = '',
  locale = 'pt-BR',
  currency = 'BRL',
}: AnimatedPriceProps) {
  const { formatted } = useCountUp({
    end: value,
    duration,
    enabled,
  });

  const displayValue = enabled
    ? Number(formatted)
    : value;

  const formattedCurrency = displayValue.toLocaleString(locale, {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  });

  return (
    <span className={className}>
      {prefix}
      {formattedCurrency}
      {suffix}
    </span>
  );
}